import React from 'react';
import { StyleSheet, Text, View, type ViewStyle } from 'react-native';
import { ticketColors } from '../../../shared/theme/ticketColors';

/**
 * Overlay en web cuando se detecta otra pestaña de Vuelto activa.
 * Evita que SQLite (OPFS) colisione entre instancias.
 */
export function SingleInstanceBlocker() {
  return (
    <View style={styles.root}>
      <View style={styles.card}>
        <Text style={styles.title}>Vuelto ya está abierto</Text>
        <Text style={styles.body}>
          Para evitar errores de sincronización, solo podés usar una pestaña de Vuelto a la vez en este
          dispositivo.
        </Text>
        <Text style={styles.hint}>Cerrá la otra pestaña y recargá esta página para continuar.</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ticketColors.bg,
    paddingHorizontal: 24,
  } as ViewStyle,
  card: {
    width: '100%',
    maxWidth: 420,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: 24,
    gap: 12,
  } as ViewStyle,
  title: {
    fontSize: 18,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  body: {
    fontSize: 14,
    lineHeight: 20,
    color: ticketColors.ink2,
  },
  hint: {
    fontSize: 13,
    lineHeight: 18,
    color: ticketColors.ink3,
  },
});
